import { linkify } from "./linkify";

/**
 * Plain text with its http(s) URLs as links that open in a new tab.
 *
 * Every segment is rendered as a JSX child, never as HTML. `noopener` keeps the
 * opened page from reaching back into this tab through `window.opener`, and
 * `noreferrer` keeps the in-app path (which carries notification ids) out of
 * the Referer header sent to a third-party survey host.
 */
export function LinkifiedText({ text }: { text: string }) {
  return (
    <>
      {linkify(text).map((segment, index) =>
        segment.kind === "link" ? (
          <a
            // Segments are positional and the list never reorders.
            key={index}
            href={segment.href}
            target="_blank"
            rel="noopener noreferrer"
            className="relative z-10 break-all font-medium text-lit underline underline-offset-2 hover:no-underline"
          >
            {segment.text}
          </a>
        ) : (
          <span key={index}>{segment.text}</span>
        ),
      )}
    </>
  );
}
